import { render } from "./ShopRecords.vue?vue&type=template&id=29845391&scoped=true"
import script from "./ShopRecords.vue?vue&type=script&lang=js"
export * from "./ShopRecords.vue?vue&type=script&lang=js"

import "./ShopRecords.vue?vue&type=style&index=0&id=29845391&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29845391"]])

export default __exports__